import { useDisclosure } from "@chakra-ui/hooks";
import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { useRecoilState } from "recoil";
import { billingAtom } from "../../../../../atoms/BillingAtom";
import SetupFee from "../../../../Settings/Modal/SetupFee";
import VideoUsersModal from "../../../../Settings/Modal/VideoUsersModal";
import StyledInput from "../../../../StyledInput";
import { StyledRadio } from "../../../../StyledRadio";
import StyledSwitch from "../../../../Switch";
import { HasFee } from "../Payment";
import {
  ActivateAccountContainer,
  ActivateLeftContainer,
  ActivationSubtitle,
  ActivationTitle,
  CardAdditionalContainer,
  CardTierContainer,
  InnerRadioButtonDiv,
  MonthSuffix,
  PurchaseAdditionalTitle,
  PurchaseContainer,
  RadioButtonDiv,
  TotalDiv,
} from "./PaymentModalStyles";

export const numberToExpression = [
  "a",
  "a",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
];

export const numberToString = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
];

const StyledNumberInput = styled(StyledInput)`
  width: 72px;
  height: 34px;
  border-radius: 5px 0px 0px 5px;
  color: #333333;
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-weight: 600;
`;

const MinusPlusButton = styled.div`
  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid #eaeaea;

  svg {
    width: 12px;
    height: 12px;
    color: #707070;
  }
`;

const PromotionalSign = styled.img`
  position: absolute;
  right: -3px;
  top: 34px;
`;

const UsersExplainLink = styled.div`
  cursor: pointer;
  color: #fb972e;
  width: fit-content;
  font-size: 15px;
  font-family: "Source Sans Pro";
  font-weight: 600;
  margin-top: 2px;
`;

export default function ActivateLeft(): JSX.Element {
  const [billing, setBilling] = useRecoilState(billingAtom);
  const {
    isOpen: isOpenInternalAndExternal,
    onClose: onCloseInternalAndExternal,
    onOpen: onOpenInternalAndExternal,
  } = useDisclosure();
  const {
    isOpen: isOpenSetupFee,
    onClose: onCloseSetupFee,
    onOpen: onOpenSetupFee,
  } = useDisclosure();
  const [hasFee, setHasFee] = useRecoilState(HasFee);

  function handleAdminsChange(add: boolean) {
    setBilling((prevState) => {
      let newValue = add
        ? (prevState.admins || 0) + 1
        : (prevState.admins || 0) - 1;
      if (newValue < 0) newValue = 0;
      return {
        ...prevState,
        admins: newValue,
      };
    });
  }

  function handleAdminsValueChange(value: number) {
    setBilling((prevState) => {
      let newValue = value;
      if (newValue < 0) newValue = 0;
      return {
        ...prevState,
        admins: newValue,
      };
    });
  }

  function handleExternalUsersValueChange(value: number) {
    setBilling((prevState) => {
      let newValue = value;
      if (newValue < 0) newValue = 0;
      return {
        ...prevState,
        externalUsers: newValue,
      };
    });
  }

  function handleExternalUsersChange(add: boolean) {
    setBilling((prevState) => {
      let newValue = add
        ? (prevState.externalUsers || 0) + 1
        : (prevState.externalUsers || 0) - 1;
      if (newValue < 0) newValue = 0;
      return {
        ...prevState,
        externalUsers: newValue,
      };
    });
  }

  useEffect(() => {
    // Handle change additional price
    let additionalSum = 0;

    additionalSum += billing.adminPrice * billing.admins;
    additionalSum += billing.externalUserPrice * billing.externalUsers;

    setBilling((billing) => ({
      ...billing,
      additionalSum,
    }));
  }, [
    billing.adminPrice,
    billing.admins,
    billing.externalUserPrice,
    billing.externalUsers,
  ]);

  return (
    <ActivateLeftContainer>
      <ActivateAccountContainer>
        <PromotionalSign src={"./images/promotional-sign.svg"} />
        <ActivationTitle>Activate Your Account </ActivationTitle>

        <ActivationSubtitle style={{ padding: "0" }}>
          Enjoy BerserkerMail’s full features when you activate.
        </ActivationSubtitle>
      </ActivateAccountContainer>

      <PurchaseContainer style={{ paddingTop: "31px" }}>
        <PurchaseAdditionalTitle>Choose Tier</PurchaseAdditionalTitle>

        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: -2 }))
          }
          active={billing.tier === -2}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === -2}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>BRAWLER</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>250 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                7.5k emails / $0.002 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === -2)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>

        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: -1 }))
          }
          active={billing.tier === -1}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === -1}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>SCRAPPER</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>1,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                30k emails / $0.002 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === -1)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>

        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 0 }))
          }
          active={billing.tier === 0}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 0}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>LOUT</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>2,500 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                75k emails / $0.002 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 0)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 1 }))
          }
          active={billing.tier === 1}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 1}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <span>BRUISER</span>
              <p>5,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                150k emails / $0.002 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 1)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 2 }))
          }
          active={billing.tier === 2}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 2}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <span>RUFFIAN</span>
              <p>10,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                300k emails / $0.00125 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 2)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 3 }))
          }
          active={billing.tier === 3}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 3}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>HENCHMAN</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>20,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                600k emails / $0.001 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 3)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 4 }))
          }
          active={billing.tier === 4}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 4}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>SAVAGE</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>30,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                900k emails / $0.001 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 4)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 5 }))
          }
          active={billing.tier === 5}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 5}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>BARBARIAN</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>40,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                1.2M emails / $0.001 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 5)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>

        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 6 }))
          }
          active={billing.tier === 6}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 6}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>BELLIGERENT</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>50,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                1.5M emails / $0.001 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 6)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>

        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 7 }))
          }
          active={billing.tier === 7}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 7}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>BERSERKER</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>75,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                2.25M emails / $0.001 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 7)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 8 }))
          }
          active={billing.tier === 8}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 8}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>RABBLE-ROUSER</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>100,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                3M emails / $0.001 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 8)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
        <CardTierContainer
          onClick={() =>
            setBilling((oldBilling) => ({ ...oldBilling, tier: 9 }))
          }
          active={billing.tier === 9}
        >
          <RadioButtonDiv style={{ paddingBottom: 5 }}>
            <StyledRadio
              inverted
              check={billing.tier === 9}
              handleCheck={() => {}}
            />
            <InnerRadioButtonDiv style={{ marginLeft: "10px" }}>
              <div style={{ display: "flex" }}>
                <span>WARLORD</span>
                {/* <div
                  style={{
                    backgroundColor: "#FFF2E5",
                    marginLeft: "10px",
                    padding: "1px 8px",
                    fontFamily: "Source Sans Pro",
                    fontSize: 13,
                    fontWeight: 400,
                    color: "#FB972E",
                    borderRadius: "10px",
                  }}
                >
                  Recommended
                </div> */}
              </div>
              <p>125,000 contacts</p>
              <span style={{ backgroundColor: "#ffff40" }}>
                3.75M emails / $0.001 per email overage
              </span>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <TotalDiv>
            <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>$</span>
            {billing.basePrice?.find((p) => p.tier === 9)?.price.toFixed(0) ||
              " --"}
            <MonthSuffix>/mo</MonthSuffix>
          </TotalDiv>
        </CardTierContainer>
      </PurchaseContainer>

      <PurchaseContainer style={{ margin: "32px 0" }}>
        <PurchaseAdditionalTitle>
          Set Up Fee
          <UsersExplainLink
            onClick={() => {
              onOpenSetupFee();
            }}
          >
            What does the set up fee cover?
          </UsersExplainLink>
        </PurchaseAdditionalTitle>
        <CardAdditionalContainer>
          <RadioButtonDiv>
            <InnerRadioButtonDiv style={{ height: "60px" }}>
              I have an email list to import
              <TotalDiv style={{ justifyContent: "flex-start" }}>
                <StyledSwitch
                  toggled={hasFee}
                  noInfo
                  whenToggled={() => setHasFee((f) => !f)}
                />
              </TotalDiv>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <RadioButtonDiv>
            {/* <InnerRadioButtonDiv style={{ height: "60px" }}>
              Quantity
              <div style={{ display: "flex", justifyContent: "center" }}>
                <StyledNumberInput
                  onChange={(e) =>
                    handleAdminsValueChange(e.target.valueAsNumber)
                  }
                  type="number"
                  value={billing.admins || 0}
                />

                <MinusPlusButton
                  style={{ borderLeft: "none", borderRight: "none" }}
                  onClick={() => handleAdminsChange(false)}
                >
                  <AiOutlineMinus />
                </MinusPlusButton>

                <MinusPlusButton
                  style={{ borderRadius: "0 4px 4px 0" }}
                  onClick={() => handleAdminsChange(true)}
                >
                  <AiOutlinePlus />
                </MinusPlusButton>
              </div>
            </InnerRadioButtonDiv> */}
          </RadioButtonDiv>
          <RadioButtonDiv>
            <InnerRadioButtonDiv
              style={{ height: "60px", textAlign: "right", width: "30px" }}
            >
              Total
              <TotalDiv style={{ width: "100%" }}>
                <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>
                  $
                </span>
                {billing.setupFeePrice !== undefined
                  ? billing.setupFeePrice
                  : 100}
              </TotalDiv>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
        </CardAdditionalContainer>
      </PurchaseContainer>

      <PurchaseContainer style={{ margin: "32px 0" }}>
        <PurchaseAdditionalTitle>
          Additional Internal BerserkerMail Users{" "}
          <UsersExplainLink
            onClick={() => {
              onOpenInternalAndExternal();
            }}
          >
            What's the difference between Internal & External users?
          </UsersExplainLink>
        </PurchaseAdditionalTitle>
        <CardAdditionalContainer>
          <RadioButtonDiv>
            <InnerRadioButtonDiv style={{ height: "60px" }}>
              Price
              <TotalDiv style={{ justifyContent: "flex-start" }}>
                <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>
                  $
                </span>
                {billing.adminPrice || 10}
              </TotalDiv>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <RadioButtonDiv>
            <InnerRadioButtonDiv style={{ height: "60px" }}>
              Quantity
              <div style={{ display: "flex", justifyContent: "center" }}>
                <StyledNumberInput
                  onChange={(e) =>
                    handleAdminsValueChange(e.target.valueAsNumber)
                  }
                  type="number"
                  value={billing.admins || 0}
                />

                <MinusPlusButton
                  style={{ borderLeft: "none", borderRight: "none" }}
                  onClick={() => handleAdminsChange(false)}
                >
                  <AiOutlineMinus />
                </MinusPlusButton>

                <MinusPlusButton
                  style={{ borderRadius: "0 4px 4px 0" }}
                  onClick={() => handleAdminsChange(true)}
                >
                  <AiOutlinePlus />
                </MinusPlusButton>
              </div>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <RadioButtonDiv>
            <InnerRadioButtonDiv
              style={{ height: "60px", textAlign: "right", width: "30px" }}
            >
              Total
              <TotalDiv style={{ width: "100%" }}>
                <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>
                  $
                </span>
                {(billing.adminPrice || 10) * (billing.admins || 0)}
                <MonthSuffix>/mo</MonthSuffix>
              </TotalDiv>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
        </CardAdditionalContainer>
      </PurchaseContainer>

      <PurchaseContainer style={{ paddingBottom: "39px" }}>
        <PurchaseAdditionalTitle>
          Additional External Users
          <UsersExplainLink
            onClick={() => {
              onOpenInternalAndExternal();
            }}
          >
            What's the difference between Internal & External users?
          </UsersExplainLink>
        </PurchaseAdditionalTitle>
        <CardAdditionalContainer>
          <RadioButtonDiv>
            <InnerRadioButtonDiv style={{ height: "60px" }}>
              Price
              <TotalDiv style={{ justifyContent: "flex-start" }}>
                <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>
                  $
                </span>
                {billing.externalUserPrice || "5 "}
                {billing.externalUserPrice && billing.externalUserPrice < 10
                  ? " "
                  : ""}
              </TotalDiv>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <RadioButtonDiv>
            <InnerRadioButtonDiv style={{ height: "60px" }}>
              Quantity
              <div style={{ display: "flex", justifyContent: "center" }}>
                <StyledNumberInput
                  onChange={(e) =>
                    handleExternalUsersValueChange(e.target.valueAsNumber)
                  }
                  type="number"
                  value={billing.externalUsers || 0}
                />

                <MinusPlusButton
                  style={{ borderLeft: "none", borderRight: "none" }}
                  onClick={() => handleExternalUsersChange(false)}
                >
                  <AiOutlineMinus />
                </MinusPlusButton>

                <MinusPlusButton
                  style={{ borderRadius: "0 4px 4px 0" }}
                  onClick={() => handleExternalUsersChange(true)}
                >
                  <AiOutlinePlus />
                </MinusPlusButton>
              </div>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
          <RadioButtonDiv>
            <InnerRadioButtonDiv
              style={{ height: "60px", textAlign: "right", width: "30px" }}
            >
              Total
              <TotalDiv style={{ width: "100%" }}>
                <span style={{ fontWeight: "normal", fontFamily: "Lato" }}>
                  $
                </span>
                {(billing.externalUserPrice || 5) *
                  (billing.externalUsers || 0)}
                <MonthSuffix>/mo</MonthSuffix>
              </TotalDiv>
            </InnerRadioButtonDiv>
          </RadioButtonDiv>
        </CardAdditionalContainer>
      </PurchaseContainer>
      <VideoUsersModal
        isOpen={isOpenInternalAndExternal}
        onClose={onCloseInternalAndExternal}
      />
      <SetupFee isOpen={isOpenSetupFee} onClose={onCloseSetupFee} />
    </ActivateLeftContainer>
  );
}
